import { Component } from '@angular/core';
import { ApiService } from '../../shared/services/api.service';
import { FOOTER_MENU, TERMS_AND_POLICIES, SOCIAL_MEDIA_ICONS } from '../../utils/constants';
import {CategoriesResponse} from "../../intefaces/categories";
import appConfig from '../../shared/config/app-config';
import { BasicLogo, LogoWhite, IpsoLogo } from '../../utils/images';

@Component({
  selector: 'footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})

export class FooterComponent {

  public footerMenu = FOOTER_MENU;
  public termsAndPolicies = TERMS_AND_POLICIES;
  public socialMediaIcons = SOCIAL_MEDIA_ICONS;

  public basicLogo = BasicLogo;
  public logoWhite = LogoWhite;
  public ipsoLogo = IpsoLogo;

  public categories: CategoriesResponse | null = null;
  orderedCategoryKeys: string[] = [];
  public footerCopyright = appConfig.footerCopyright;

  vettimesUrl = appConfig.vettimesUrl

  constructor(private apiService: ApiService) {this.fetchCategories()}

  isHiddenCategory(category: any): boolean {
    return ['Jobs', 'More'].includes(category);
  }

  setOrderedCategoryKeys(categories: CategoriesResponse | null): void {
    if (categories) {
      this.orderedCategoryKeys = Object.keys(categories);
      this.orderedCategoryKeys.sort((a, b) => {
        if (a === 'News') return -1;
        if (b === 'News') return 1;
        return 0;
      });
    }
  }

  fetchCategories(): void {
    this.apiService.httpGetVettimes('api/categories').subscribe((response: any) => {
      this.categories = response.data;
      this.setOrderedCategoryKeys(response.data);
    }, (error) => {
      console.error('Error fetching categories:', error);
      this.categories = null;
    })
  }
}
